export default theme => ({
    root: {
        padding: theme.spacing(1, 0),
    },
    // Two-column row: the input flexes, the send button is a fixed column pinned to
    // the bottom (align-items: flex-end). Because the input only occupies the space
    // left of the button, its text wraps at its own edge and never reaches the
    // button — no overlap, at any length or width.
    card: {
        display: 'flex',
        alignItems: 'flex-end',
        gap: theme.spacing(1),
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 10,
        boxShadow: '0px 1px 3px rgba(0,0,0,0.06), 0px 1px 2px rgba(0,0,0,0.04)',
        padding: theme.spacing(1, 2),
    },
    // Vertically centering the resting text against the (taller) send button takes
    // two paired styles: align-self: stretch here makes the outer TextField fill the
    // row height, and fieldRoot's height: 100% propagates that to the inner
    // MuiInputBase, whose align-items: center then centers the single line. (The
    // inner field can't use align-self — it isn't a flex item of the row.) On
    // multiline the input is already the tall one, so this is a no-op and the
    // bottom-aligned button hugs the last line.
    input: {
        flex: '1 1 auto',
        minWidth: 0,
        alignSelf: 'stretch',
    },
    fieldRoot: {
        padding: 0,
        height: '100%',
    },
    fieldInput: {
        padding: theme.spacing(0.5, 0),
    },
    fieldOutline: {
        border: 'none',
    },
    // Rounded-square override of MUI's circular default — a stopgap until the design
    // system ships a proper "square" icon-button variant, at which point drop this.
    sendButton: {
        flex: '0 0 auto',
        borderRadius: theme.shape.borderRadius * 2,
        backgroundColor: theme.palette.grey[600],
        color: theme.palette.common.white,
        '&:hover': {
            backgroundColor: theme.palette.grey[700],
        },
        '&.Mui-disabled': {
            backgroundColor: theme.palette.action.disabledBackground,
            color: theme.palette.action.disabled,
        },
    },
    // Side panel / pop-up: a smaller fixed square than the full-screen default.
    sendButtonCompact: {
        width: 36,
        height: 36,
        padding: 0,
    },
});
